import { render, staticRenderFns } from "./PopupBrandInfo.vue?vue&type=template&id=1530f49c&scoped=true&"
import script from "./PopupBrandInfo.vue?vue&type=script&lang=js&"
export * from "./PopupBrandInfo.vue?vue&type=script&lang=js&"
import style0 from "./PopupBrandInfo.vue?vue&type=style&index=0&id=1530f49c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1530f49c",
  null
  
)

export default component.exports